import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';

import { GlobalDataService } from '@core/services/global-data.service';
import { MatStepper } from '@angular/material/stepper';
import { ProduitService } from '@core/services/produit.service';
import { ActivatedRoute, NavigationBehaviorOptions, Params, Router } from '@angular/router';
import { environment } from 'environments/environment';
import { CampagneTypologieService } from '@core/services';
import { navPaths } from '@core/models/support.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-campagne-typologie',
  templateUrl: './campagne-typologie.component.html',
  styleUrls: ['./campagne-typologie.component.scss']
})
export class CampagneTypologieComponent implements OnInit, AfterViewInit, OnDestroy {

private navigationOption: NavigationBehaviorOptions = {};
private activatedRouteSub: Subscription;
private stepperSub: Subscription;
private produitsLoadSub: Subscription;
private typologieOutletReady = false;
private pendingNavigationPath: string;

  constructor(
    private _formBuilder: FormBuilder,
    private readonly activatedRoute: ActivatedRoute,
    private _GlobalDataService: GlobalDataService,
    private _CampagneTypologieService: CampagneTypologieService,
    private _ProduitService: ProduitService,
  ) { 
    this.activatedRoute.queryParams.subscribe(() => {
      this.sanitizeObjectParams();
      
    });

    // this._ProduitService.getList()
    //   .subscribe(
    //     response => this.getAllProducts(response)
    //   );

    // this._GlobalDataService.listEnveloppeProduits$.subscribe(res => {
    //   if (res.length > 0) {
    //     this._CampagneTypologieService.dataEnveloppes = this._GlobalDataService.distinct(res, 'CodeEnveloppe');
    //   }
    // });
  }

  ngOnInit(): void {
    this._CampagneTypologieService.SupportFormGroup = this._formBuilder.group({
      CodeTypologie: new FormControl(this._GlobalDataService.Campagne.CodeTypologie),
      CodeSupport: new FormControl(this._GlobalDataService.Campagne.CodeSupport),
      CodeDimensionsSupport: new FormControl(this._GlobalDataService.Campagne.CodeDimensionsSupport),
      CodeGrammageSupport: new FormControl(this._GlobalDataService.Campagne.CodeGrammageSupport),
      CodeFinitionSupport: new FormControl(this._GlobalDataService.Campagne.CodeFinitionSupport),
      CodeEncreSupport: new FormControl(this._GlobalDataService.Campagne.CodeEncreSupport)
    });

    this._CampagneTypologieService.EnveloppeFormGroup = this._formBuilder.group({
      CodeTypologie: new FormControl(this._GlobalDataService.Campagne.CodeTypologie),
      CodeEnveloppe: new FormControl(this._GlobalDataService.Campagne.CodeEnveloppe),
      CodeDimensionsEnveloppe: new FormControl(this._GlobalDataService.Campagne.CodeDimensionsEnveloppe),
      CodeGrammageEnveloppe: new FormControl(this._GlobalDataService.Campagne.CodeGrammageEnveloppe),
      CodeFinitionEnveloppe: new FormControl(this._GlobalDataService.Campagne.CodeFinitionEnveloppe),
      CodeEncreEnveloppe: new FormControl(this._GlobalDataService.Campagne.CodeEncreEnveloppe)
    });
    this.ensureProductsLoadedThenInit();
  }

  ngAfterViewInit(): void {
    this.typologieOutletReady = true;
    this.navigateToPendingPath();
  }

    private ensureProductsLoadedThenInit(): void {
    if (Array.isArray(this._GlobalDataService.produits) && this._GlobalDataService.produits.length > 0) {
      this.Init();
      return;
    }

    this.produitsLoadSub?.unsubscribe();
    this.produitsLoadSub = this._ProduitService.getList().subscribe({
      next: (response: any) => {
        this._GlobalDataService.produits = response?.produit || [];
        this.Init();
      },
      error: () => {
        this._GlobalDataService.produits = [];
        this.Init();
      },
    });
  }

  private sanitizeObjectParams(): void {
    const sourceParams: Params = this._GlobalDataService.objectParams || {};
    const cleanedParams: Params = {};
    Object.keys(sourceParams).forEach((key) => {
      const value = sourceParams[key];
      if (typeof value !== 'undefined' && value !== null && value !== '') {
        cleanedParams[key] = value;
      }
    });

    this._GlobalDataService.objectParams = cleanedParams;
  }



  Init() {
    // Typologie (Type de support)
    this._CampagneTypologieService.dataSupportTypologies = this._GlobalDataService.distinct(this._GlobalDataService.produits, 'CodeTypologie');

    // Support
    this._CampagneTypologieService.dataSupports = this._GlobalDataService.produits
      .filter((element: {
        CodeTypologie: string | undefined;
      }) => element.CodeTypologie == this._GlobalDataService.Campagne.CodeTypologie);
    this._CampagneTypologieService.dataSupports = this._GlobalDataService.distinct(this._CampagneTypologieService.dataSupports, 'CodeSupport');

    // Dimension
    this._CampagneTypologieService.dataDimensionsSupports = this._GlobalDataService.produits
      .filter((element: { CodeSupport: string | undefined; CodeTypologie: string | undefined; }) => element.CodeSupport == this._GlobalDataService.Campagne.CodeSupport
        && element.CodeTypologie == this._GlobalDataService.Campagne.CodeTypologie)
    this._CampagneTypologieService.dataDimensionsSupports = this._GlobalDataService.distinct(this._CampagneTypologieService.dataDimensionsSupports, 'CodeDimensionsSupport');

    // Grammage
    this._CampagneTypologieService.dataGrammagesSupports = this._GlobalDataService.produits
      .filter((element: { CodeDimensionsSupport: string | undefined; CodeSupport: string | undefined; CodeTypologie: any; }) => element.CodeDimensionsSupport == this._GlobalDataService.Campagne.CodeDimensionsSupport
        && element.CodeSupport == this._GlobalDataService.Campagne.CodeSupport
        && element.CodeTypologie == this._GlobalDataService.Campagne.CodeTypologie)
    this._CampagneTypologieService.dataGrammagesSupports = this._GlobalDataService.distinct(this._CampagneTypologieService.dataGrammagesSupports, 'CodeGrammageSupport');

    // Finition
    this._CampagneTypologieService.dataFinitionsSupports = this._GlobalDataService.produits
      .filter((element: { CodeGrammageSupport: any; CodeDimensionsSupport: any; CodeSupport: any; CodeTypologie: any; }) => element.CodeGrammageSupport == this._GlobalDataService.Campagne.CodeGrammageSupport
        && element.CodeDimensionsSupport == this._GlobalDataService.Campagne.CodeDimensionsSupport
        && element.CodeSupport == this._GlobalDataService.Campagne.CodeSupport
        && element.CodeTypologie == this._GlobalDataService.Campagne.CodeTypologie)
    this._CampagneTypologieService.dataFinitionsSupports = this._GlobalDataService.distinct(this._CampagneTypologieService.dataFinitionsSupports, 'CodeFinitionSupport');

    // Encre
    this._CampagneTypologieService.dataEncresSupports = this._GlobalDataService.produits
      .filter((element: { CodeFinitionSupport: any; CodeGrammageSupport: any; CodeDimensionsSupport: any; CodeSupport: any; CodeTypologie: any; }) => element.CodeFinitionSupport == this._GlobalDataService.Campagne.CodeFinitionSupport
        && element.CodeGrammageSupport == this._GlobalDataService.Campagne.CodeGrammageSupport
        && element.CodeDimensionsSupport == this._GlobalDataService.Campagne.CodeDimensionsSupport
        && element.CodeSupport == this._GlobalDataService.Campagne.CodeSupport
        && element.CodeTypologie == this._GlobalDataService.Campagne.CodeTypologie)
    this._CampagneTypologieService.dataEncresSupports = this._GlobalDataService.distinct(this._CampagneTypologieService.dataEncresSupports, 'CodeFinitionSupport');

    this._CampagneTypologieService.dataEnveloppes= this._GlobalDataService.produits
      .filter((element: { CodeTypologie: string | undefined; CodeSupport: string | undefined; CodeDimensionsSupport: string | undefined; CodeGrammageSupport: string | undefined; CodeFinitionSupport: string | undefined; CodeEncreSupport: string | undefined; }) => element.CodeTypologie == this._GlobalDataService.Campagne.CodeTypologie
        && element.CodeSupport == this._GlobalDataService.Campagne.CodeSupport
        && element.CodeDimensionsSupport == this._GlobalDataService.Campagne.CodeDimensionsSupport
        && element.CodeGrammageSupport == this._GlobalDataService.Campagne.CodeGrammageSupport
        && element.CodeFinitionSupport == this._GlobalDataService.Campagne.CodeFinitionSupport
        && element.CodeEncreSupport == this._GlobalDataService.Campagne.CodeEncreSupport);
    this._CampagneTypologieService.dataEnveloppes = this._GlobalDataService.distinct(this._CampagneTypologieService.dataEnveloppes, 'CodeEnveloppe');

    this.navigate();
  }

  navigate() {
    const path = this._GlobalDataService.Campagne.CodeTypologie
      ? navPaths.selection
      : navPaths.format;

    if (!this.typologieOutletReady) {
      this.pendingNavigationPath = path;
      return;
    }

    this._CampagneTypologieService.navigate(path, this.activatedRoute, this.navigationOption);
  }

  private navigateToPendingPath(): void {
    if (!this.pendingNavigationPath) {
      return;
    }

    const path = this.pendingNavigationPath;
    this.pendingNavigationPath = undefined;
    this._CampagneTypologieService.navigate(path, this.activatedRoute, this.navigationOption);
  }
  ngOnDestroy() {
    this.activatedRouteSub?.unsubscribe();
    this.stepperSub?.unsubscribe();
    this.produitsLoadSub?.unsubscribe();
  }
}
